export default __webpack_public_path__ + "static/media/phone-icon.280dba0c.svg";